// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"aaaeff7b","126":"f793ad0b","184":"d83e150a","291":"f354cb3a","318":"f9c22bb1","515":"3ef30438","787":"119d83d5","788":"2b0d479d","904":"04bec718","935":"a7677df3","964":"397afc47"}[chunkId] + ".chunk.js";
};